import * as types from './action-types'

export const saveTimeDependentRates = (data, transform = true, replaceModal = false) => {
  return { type: types.TIME_DEPENDENT_RATES_SAVE_BEGIN, data, meta: { transform, replaceModal } }
}

export const updateTimeDependentRates = (data, transform = true, replaceModal = false) => {
  return { type: types.TIME_DEPENDENT_RATES_UPDATE_BEGIN, data, meta: { transform, replaceModal } }
}
